import { all, fork } from 'redux-saga/effects';

import templateSagas from './template';

export function* rootSaga() {
  yield all([fork(templateSagas)]);
}
